import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ReCenterIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 23 23",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#clip0_217_454)",
                            children: [
                                _jsx("path", {
                                    d: "M21.05 9.96h-2a8.1 8.1 0 00-7-6.93V1.05a1 1 0 00-2 0v2a8.1 8.1 0 00-7 6.93h-2a1.035 1.035 0 000 2.07h2a8.11 8.11 0 007 7v2a1.05 1.05 0 102.1 0v-2a8.11 8.11 0 007-7h2a1.05 1.05 0 000-2.1l-.1.01zm-10 7a5.9 5.9 0 115.9-5.91 5.91 5.91 0 01-5.9 5.9v.01z"
                                }),
                                _jsx("path", {
                                    d: "M11.05 15.05a4 4 0 100-8 4 4 0 000 8z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_217_454",
                                children: _jsx("path", {
                                    d: "M0 0h22.1v22.1H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ReCenterIcon.isCarinaIcon = true;
export default ReCenterIcon;
